import * as authService from './auth.service';

export * from './auth.service';
export default authService;
